<template src="../templates/normal_fcont_61.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import AppDownloadPhotoPlusJp from '../components/AppDownloadPhotoPlusJp'

import { Carousel,Slide } from 'uiv'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
export default {
  name: 'app',
  data() {
    return {
      articleId: '61',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
   LabelFunMessage,FuncSearchRecommendLink,Carousel,Slide,
   FuncSearchGalleryQR,ReleaseDateForArticle,AppDownloadPhotoPlusJp
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['61-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['61-2']}
    ]};
  }
};
</script>
<style />


